import React from 'react';
import { Link } from 'react-router-dom';

interface FAQItem {
  id: string;
  question: string;
  answer: string;
  isDefault?: boolean;
}

const FAQSection: React.FC = () => {
  const faqItems: FAQItem[] = [
    {
      id: "collapseOne",
      question: "How do I get started with WiZiAi for JEE/NEET preparation?",
      answer: "Simply sign up for free and create your personalized learning profile. Our AI system will assess your current knowledge level and create a customized study plan. You can start with our free mock tests and gradually explore premium features like detailed analytics and personalized coaching.",
      isDefault: true
    },
    {
      id: "collapseTwo",
      question: "What makes WiZiAi different from other online coaching platforms?",
      answer: "WiZiAi uses advanced artificial intelligence to provide personalized learning experiences. Our platform adapts to your learning pace, identifies weak areas automatically, and provides targeted practice questions. We offer real-time performance analytics and AI-powered doubt resolution that's available 24/7."
    },
    {
      id: "collapseThree",
      question: "How accurate are WiZiAi's mock tests compared to actual JEE/NEET exams?",
      answer: "Our mock tests are designed by expert educators and follow the exact pattern, difficulty level, and syllabus of JEE Main, JEE Advanced, and NEET exams. We continuously update our question bank based on recent exam trends and maintain 95%+ accuracy in predicting actual exam difficulty levels."
    },
    {
      id: "collapseFour",
      question: "Can I track my preparation progress and performance analytics?",
      answer: "Yes! WiZiAi provides comprehensive performance dashboards with detailed analytics including subject-wise scores, time management analysis, improvement trends, and personalized recommendations. You can track your rank among peers and get insights into areas that need more focus."
    },
    {
      id: "collapseFive",
      question: "What subjects and topics are covered in WiZiAi's curriculum?",
      answer: "We cover the complete JEE and NEET syllabus including Physics, Chemistry, Mathematics (for JEE), and Biology (for NEET). Each subject includes detailed theory, practice questions, previous year papers, and video explanations by expert faculty members."
    },
    {
      id: "collapseSix",
      question: "Is there any offline support or can I download content for offline study?",
      answer: "Yes, our mobile app allows you to download practice tests, video lectures, and study materials for offline access. We also provide printable PDF notes and question banks. Additionally, our support team is available via chat and email for any technical assistance."
    }
  ];

  return (
    <div className="container-fluid faq-section bg-light py-5">
      <div className="container py-5">
        <div className="row g-5">
          <div className="col-lg-6 wow fadeInLeft" data-wow-delay="0.2s">
            <h4 className="text-primary">Student Support</h4>
            <h1 className="display-4 mb-4">Frequently Asked Questions</h1>
            <p className="mb-4">
              Have questions about WiZiAi's JEE and NEET preparation programs? 
              Find answers to the most common questions about our AI-powered learning platform, 
              mock tests, and personalized coaching features.
            </p>
            <Link 
              className="btn py-3 px-5" 
              to="/contact"
              style={{ 
                background: 'linear-gradient(135deg, #667eea, #764ba2)',
                border: 'none',
                borderRadius: '25px',
                color: 'white',
                transition: 'all 0.3s ease'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-2px)';
                e.currentTarget.style.boxShadow = '0 8px 16px rgba(102, 126, 234, 0.4)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = 'none';
              }}
            >
              <i className="fas fa-question-circle me-2"></i>
              Ask Your Question
            </Link>
          </div>
          <div className="col-xl-6 wow fadeInRight" data-wow-delay="0.4s">
            <div className="h-100">
              <div className="accordion" id="accordionExample">
                {faqItems.map((faq, index) => (
                  <div key={faq.id} className="accordion-item">
                    <h2 className="accordion-header" id={`heading${index + 1}`}>
                      <button 
                        className={`accordion-button ${!faq.isDefault ? 'collapsed' : ''}`} 
                        type="button" 
                        data-bs-toggle="collapse"
                        data-bs-target={`#${faq.id}`} 
                        aria-expanded={faq.isDefault ? "true" : "false"} 
                        aria-controls={faq.id}
                      >
                        Q: {faq.question}
                      </button>
                    </h2>
                    <div 
                      id={faq.id} 
                      className={`accordion-collapse collapse ${faq.isDefault ? 'show active' : ''}`}
                      aria-labelledby={`heading${index + 1}`} 
                      data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body">
                        A: {faq.answer}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FAQSection;
